import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { take } from 'rxjs/operators';
import { CrmSalesSalesOrderLine } from 'src/app/services/service/DataProviders/CrmSalesSalesOrderLine';
import { GeneralProductsProducts } from 'src/app/services/service/DataProviders/GeneralProductsProducts';
import * as _ from 'lodash';

@Component({
  selector: 'app-sales',
  templateUrl: './sales.component.html',
  styleUrls: ['./sales.component.scss']
})
export class SalesComponent implements OnInit {

  constructor(
    private productService: GeneralProductsProducts,
    private salesLineService: CrmSalesSalesOrderLine
    
    ) { }

  public from = moment().startOf('month').format('DD.MM.YYYY');
  public to = moment().format('DD.MM.YYYY');
  public PartNumber = null; //'00120001';
  public theProduct = null;
  public sales = null;
  public total = 0;

  ngOnInit(): void {
  }

  async generate() {
    this.sales = null;
    this.total = 0;

    if(this.PartNumber.length == 0) {
      return;
    }

    const product = await this.productService.findProduct(this.PartNumber).pipe(take(1)).toPromise();

    this.theProduct = _.get(product, 'value[0]', null);

    if(_.isNull(this.theProduct)) {
      return;
    }

    let salesLines = await this.salesLineService.findByProduct(
      this.theProduct.Id,
      moment(this.from, 'DD.MM.YYYY'),
      moment(this.to, 'DD.MM.YYYY')
      ).pipe(take(1)).toPromise();

    salesLines = _.get(salesLines, 'value', []);
    // console.log(salesLines)
    const grouped = _.groupBy(salesLines, (s) => {
      console.log(s);
      return moment(s.SalesOrder.DocumentDate).format('DD.MM.YYYY');
    });
    // console.log(grouped);
    const quantityByDay = [];
    for(let key in grouped) {
      const g = grouped[key];
      const totalPerDay = _.sumBy(g, 'QuantityBase.Value');
      this.total += totalPerDay;
      quantityByDay.push({
        date: key,
        quantity: totalPerDay + ' ' + _.get(g, '[0].QuantityBase.Unit', ''),
      });
    }

    this.sales = _.orderBy(quantityByDay, d => moment(d.date, 'DD.MM.YYYY').unix());
  }

}
